import React from 'react'



class QuestionInit extends React.Component {

render()  {
  const {doctor, consultCategory} = this.props
  console.log(this.props)
  let doctorFullName, exp, category
  let avgResponse = 12
  let textArray = [
    `تلاش میکنم تا ${avgResponse} ساعت آینده پاسخ شما را بدهم`,
    `بعد از شروع مکالمه، شما امکان ارسال جواب آزمایش یا عکس های پزشکی و پیام صوتی را هم خواهید داشت`
  ]

  if (doctor) {
    doctorFullName = doctor.fname + ' ' + doctor.lname

    exp = doctor.expUnis?.length ?
      doctor.expUnis[0].expertise.name :
      doctor.spUnis?.length && doctor.spUnis[0] ?
      doctor.spUnis[0].specialty.name : ''

    avgResponse = doctor.DoctorConsultInfo?.avgResponse || 12

    textArray = [
      `سلام دکتر ${doctorFullName} هستم${exp && ' متخصص '+exp}`,
      ...textArray
    ]
  } else if(consultCategory){
    textArray = [
      `سلام، شما در حال مکالمه با یکی از پزشکان تخصص ${consultCategory.name} هستید`,
      ...textArray
    ]
  }

  return (
    <div className="MessageRow">
    {textArray.map(txt =>
      <div className="ChatMessage" key={txt}>
      <span className="text">{txt}</span>
      </div>
    )}
    </div>
  )
}
}

export default QuestionInit

